import type { SVGProps } from "react";

export default function SolarToolboxLinear(props: SVGProps<SVGSVGElement>) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" {...props}>
            <g fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth={1.5}>
                <rect width="12.051" height="20" x="2" y="18.051" rx="3" transform="rotate(-90 2 18.051)" />
                <path d="M16.52 6c0-1.886 0-2.828-.586-3.414C15.348 2 14.406 2 12.52 2H11.48c-1.886 0-2.829 0-3.415.586C7.48 3.172 7.48 4.114 7.48 6" />
                <path d="M2 12h3M18.784 12H22M8.784 12H15" />
                <path d="M8.405 11H5.378A.378.378 0 0 0 5 11.378v1.636c0 .155.094.294.238.351l.53.212a3.2 3.2 0 0 0 2.248 0l.53-.212a.4.4 0 0 0 .238-.351v-1.636A.378.378 0 0 0 8.405 11Z" />
                <path d="M18.405 11h-3.027A.378.378 0 0 0 15 11.378v1.636c0 .155.094.294.238.351l.53.212a3.2 3.2 0 0 0 2.248 0l.53-.212a.4.4 0 0 0 .238-.351v-1.636a.378.378 0 0 0-.379-.378Z" />
            </g>
        </svg>
    );
}
